var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.933594,
    width: 16,
    height: 15.4754,
    rx: 5.2459,
    fill: "#FF4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3062 6.8256C10.3405 6.79054 10.3816 6.76268 10.4268 6.74366C10.4721 6.72464 10.5207 6.71484 10.5698 6.71484C10.6189 6.71484 10.6675 6.72464 10.7128 6.74366C10.7581 6.76268 10.7991 6.79054 10.8335 6.8256C10.9775 6.97115 10.9795 7.20633 10.8385 7.35439L7.86067 10.8746C7.82686 10.9117 7.78583 10.9416 7.74009 10.9623C7.69435 10.983 7.64487 10.9942 7.59466 10.9951C7.54446 10.9961 7.49459 10.9868 7.44811 10.9678C7.40162 10.9488 7.3595 10.9205 7.32432 10.8847L5.51235 9.04852C5.44247 8.97726 5.40332 8.88142 5.40332 8.78161C5.40332 8.6818 5.44247 8.58597 5.51235 8.5147C5.54672 8.47963 5.58774 8.45177 5.63301 8.43275C5.67827 8.41374 5.72688 8.40394 5.77599 8.40394C5.82509 8.40394 5.8737 8.41374 5.91896 8.43275C5.96423 8.45177 6.00525 8.47963 6.03962 8.5147L7.57663 10.0724L10.2961 6.83668L10.3062 6.8256Z",
    fill: "#FCFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImg);
export default __webpack_public_path__ + "static/media/CheckImg.ef13b8e4f83d93cd5ca8551fac40f114.svg";
export { ForwardRef as ReactComponent };